const translates: { [key: string]: { id: string } } = {
  jobsOverview: { id: 'jobs_overview' },
  teams: { id: 'teams' },
  users: { id: 'users' },
  managementAppName: { id: 'management_ui_app_name' },
  notStarted: { id: 'not_started' },
  not_started: { id: 'not_started' },
  completed: { id: 'completed' },
  inProgress: { id: 'in_progress' },
  in_progress: { id: 'in_progress' },
  todo: { id: 'todo' },
  pending: { id: 'pending' },
  createNewJob: { id: 'create_new_job' },
  createNewJobForToday: { id: 'create_new_job_for_today' },
  noActiveJobsMessage: { id: 'no_active_jobs_message' },
  noResultsMessage: { id: 'no_results' },
  lastWeek: { id: 'last_week' },
  last_week: { id: 'last_week' },
  yesterday: { id: 'yesterday' },
  today: { id: 'today' },
  tomorrow: { id: 'tomorrow' },
  nextWeek: { id: 'next_week' },
  next_week: { id: 'next_week' },
  createdBy: { id: 'createdBy' },
  overdue: { id: 'overdue' },
  respectFilters: { id: 'respect_filters' },
  assignee: { id: 'assignee' },
  due: { id: 'due' },
  dueDate: { id: 'due_date' },
  status: { id: 'status' },
  duplicated: { id: 'duplicated' },
  filters: { id: 'filters' },
  allSites: { id: 'all_sites' },
  clearFilter: { id: 'clear_filter' },
  filterAppliedResultsHidden: { id: 'filter_applied_results_hidden' },
  media: { id: 'media' },
  recurrence: { id: 'recurrence' },
  activeFilters: { id: 'active_filters' },
  addFilter: { id: 'add_filter' },
  search: { id: 'search' },
  never: { id: 'never' },
  daily: { id: 'daily' },
  weekly: { id: 'weekly' },
  biweekly: { id: 'biweekly' },
  monthly: { id: 'monthly' },
  hasMedia: { id: 'has_media_content' },
  hasNoMedia: { id: 'has_no_media_content' },
  modifiedBy: { id: 'modified_by' },
  jobId: { id: 'job_id' },
  tasksCompleted: { id: 'tasks_completed' },
  reassignSuccessMessage: { id: 'reassign_success_message' },
  reassignErrorMessage: { id: 'reassign_error_message' },
  site: { id: 'site' },
  delete: { id: 'delete' },
  deleteJobSeries: { id: 'delete_job_series' },
  cancel: { id: 'cancel' },
  successfulCreateJobMessage: { id: 'successful_create_job_message' },
  failedCreateJobMessage: { id: 'failed_create_job_message' },
  deleteJobDialogMessage: { id: 'delete_job_dialog_message' },
  deleteJobSeriesDialogMessage: { id: 'delete_job_series_dialog_message' },
  deleteJobSuccessMessage: { id: 'delete_job_success_message' },
  deleteJobSeriesSuccessMessage: { id: 'delete_job_series_success_message' },
  deleteJobErrorMessage: { id: 'delete_job_error_message' },
  deleteJobSeriesErrorMessage: { id: 'delete_job_series_error_message' },
  duplicate: { id: 'duplicate' },
  duplicateMessage: { id: 'duplicate_message' },
  duplicateErrorMessage: { id: 'duplicate_error_message' },
  confirmTaskMessage: { id: 'confirm_task_message' },
  deleteTaskSuccessMessage: { id: 'delete_task_success_message' },
  deleteTaskErrorMessage: { id: 'delete_task_error_message' },
  openInJobs: { id: 'open_in_jobs' },
  dateCreated: { id: 'date_created' },
  dateUpdated: { id: 'date_updated' },
  published: { id: 'published' },
  draft: { id: 'draft' },
  units: { id: 'units' },
  all: { id: 'all' },
  allUnits: { id: 'all_locuses' },
  allUnitGroups: { id: 'all_unit_groups' },
  allUnitsAndGroups: { id: 'all_units_and_groups' },
  expandSites: { id: 'expand_sites' },
  collapseSites: { id: 'collapse_sites' },
  jobsName: { id: 'jobs_name' },
  scheduling: { id: 'scheduling' },
  startDate: { id: 'start_date' },
  endDate: { id: 'end_date' },
  jobName: { id: 'job_name' },
  planNewJob: { id: 'plan_new_job' },
  workflow: { id: 'workflow' },
  chooseWorkflow: { id: 'choose_workflow' },
  siteAndUnits: { id: 'site_and_units' },
  selectSite: { id: 'select_site' },
  assignment: { id: 'assignment' },
  additionalSettings: { id: 'additional_settings' },
  actions: { id: 'actions' },
  sites: { id: 'sites' },
  unitGroups: { id: 'unit_groups' },
  selectUnits: { id: 'select_units' },
  start: { id: 'start' },
  noData: { id: 'no_data' },
  custom: { id: 'custom' },
  repeat: { id: 'repeat' },
  every: { id: 'every' },
  at: { id: 'at' },
  endsAfter: { id: 'ends_after' },
  onThe: { id: 'on_the' },
  each: { id: 'each' },
  first: { id: 'first' },
  second: { id: 'second' },
  third: { id: 'third' },
  fourth: { id: 'fourth' },
  fifth: { id: 'fifth' },
  last: { id: 'last' },
  monday: { id: 'monday' },
  tuesday: { id: 'tuesday' },
  wednesday: { id: 'wednesday' },
  thursday: { id: 'thursday' },
  friday: { id: 'friday' },
  saturday: { id: 'saturday' },
  sunday: { id: 'sunday' },
  mon: { id: 'mon' },
  tue: { id: 'tue' },
  wed: { id: 'wed' },
  thu: { id: 'thu' },
  fri: { id: 'fri' },
  sat: { id: 'sat' },
  sun: { id: 'sun' },
  months: { id: 'months' },
  weeks: { id: 'weeks' },
  occurrences: { id: 'occurrences' },
  regular: { id: 'regular' },
  searchByRuleName: { id: 'search_by_rule_name' },
  ruleName: { id: 'rule_name' },
  then: { id: 'then' },
  days: { id: 'days' },
  save: { id: 'save' },
  when: { id: 'when' },
  usingReceivedData: { id: 'using_received_data' },
  enterRuleName: { id: 'enter_rule_name' },
  applyToSites: { id: 'apply_to_sites' },
  setAdditionalDelay: { id: 'set_additional_delay' },
  selectJob: { id: 'select_job' },
  selectJobTask: { id: 'select_job_task' },
  stop: { id: 'stop' },
  isInProgress: { id: 'is_in_progress' },
  isCompleted: { id: 'is_completed' },
  noDelay: { id: 'no_delay' },
  nextDay: { id: 'next_day' },
  afterOneWeek: { id: 'after_one_week' },
  whenCompleted: { id: 'when_completed' },
  ruleCreationSuccess: { id: 'rule_creation_success' },
  ruleCreationFailure: { id: 'rule_creation_failure' },
  ruleExistsMessage: { id: 'rule_exists_message' },
  checkRuleNameMessage: { id: 'check_rule_name_message' },
  fillRequiredFieldsMessage: { id: 'fill_required_fields_message' },
  stopRepeat: { id: 'stop_repeat' },
  day_s: { id: 'day_s' },
  week_s: { id: 'week_s' },
  month_s: { id: 'month_s' },
  occurrence_s: { id: 'occurrence_s' },
  ruleUpdateSuccess: { id: 'rule_update_success' },
  ruleUpdateFailure: { id: 'rule_update_failure' },
  active: { id: 'active' },
  inactive: { id: 'inactive' },
  editRuleName: { id: 'edit_rule_name' },
  dueDateIs: { id: 'due_date_is' },
  afterStartAt: { id: 'after_start_at' },
  andInputs: { id: 'and_inputs' },
  selectInputs: { id: 'select_inputs' },
  job: { id: 'job' },
  task: { id: 'task' },
  valueIs: { id: 'value_is' },
  chooseValue: { id: 'choose_value' },
  yes: { id: 'yes' },
  no: { id: 'no' },
  notSelected: { id: 'not_selected' },
  invalidTitle: { id: 'invalid_title' },
  editAssignees: { id: 'edit_assignees' },
  defaultAssignees: { id: 'default_assignees' },
  searchBySite: { id: 'search_by_site' },
  ends: { id: 'ends' },
  after: { id: 'after' },
  startOn: { id: 'start_on' },
  newJob: { id: 'new_job' },
  created: { id: 'created' },
  date: { id: 'date' },
  console: { id: 'console' },
  is: { id: 'is' },
  on: { id: 'on' },
  everyDay: { id: 'every_day' },
  onceAWeek: { id: 'once_a_week' },
  everyWeekday: { id: 'every_weekday' },
  deleted: { id: 'deleted' },
  dateDeleted: { id: 'date_deleted' },
  reasonForDeletion: { id: 'reason_for_deletion' },
  deletedBy: { id: 'deleted_by' },
  restore: { id: 'restore' },
  restoreSeries: { id: 'restore_series' },
  restoreJobDialogMessage: { id: 'restore_job_dialog_message' },
  restoreJobSeriesDialogMessage: { id: 'restore_job_series_dialog_message' },
  restoreJobSuccessMessage: { id: 'restore_job_success_message' },
  restoreJobSeriesSuccessMessage: { id: 'restore_job_series_success_message' },
  restoreJobErrorMessage: { id: 'restore_job_error_message' },
  restoreJobSeriesErrorMessage: { id: 'restore_job_series_error_message' },
}

export default translates
